export const SET_TITLE_ICON = 'SET_TITLE_ICON';
export const SET_MAIN_TITLE = 'SET_MAIN_TITLE';

export const MASTER_DATA_MUTATION = {
  SET_GET_PARAMETERS: 'SET_GET_PARAMETERS',
};

export const AUTH_MUTATION = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  GET_USER: 'GET_USER',
} as const;

export const NOTIFICATION_MUTATION = {
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
} as const;

export const SCHOOL_MUTATION = {
  GET_SCHOOLS: 'GET_SCHOOLS',
  GET_STATUSES: 'GET_STATUSES',
  GET_ADMIN_SCHOOLS: 'GET_ADMIN_SCHOOLS',
  SAVE_PUBLISH_DATES: 'SAVE_PUBLISH_DATES',
  TO_PRIVATE: 'TO_PRIVATE',
  RESET_PUBLISH: 'RESET_PUBLISH',
  CHANGE_ENABLED: 'CHANGE_ENABLED',
} as const;

export const DOCUMENT_MUTATION = {
  GET_OFFICIAL_DOCUMENT: 'GET_OFFICIAL_DOCUMENT',
  SAVE_OFFICIAL_DOCUMENT: 'SAVE_OFFICIAL_DOCUMENT',
  GET_RESULT_DOCUMENT: 'GET_RESULT_DOCUMENT',
  SAVE_RESULT_DOCUMENT: 'SAVE_RESULT_DOCUMENT',
} as const;
